module.exports = __webpack_public_path__ + "img/Rainbow-mobile.013e05e5.png";